import { useMutation } from '@tanstack/react-query';
import { useUserState } from '../../hooks/context/useUserState';
import { useTranslate } from '../../hooks/context/useTranslate';
import { getIsMobile } from '../../utils/helpers';
import { requestSetLanguage } from '../requests/requestSetLanguage';
import { requestSetLanguageUser } from '../requests/requestSetLanguageUser';
import { useApp } from './useApp';
import { START_SESSION, SET_LANGUAGE } from '../../constants';
import toast from 'react-hot-toast';

type SetLanguageArgs = {
  language: string;
  sessionToken?: string;
  loggedIn?: boolean;
};

export const useLanguageSet = () => {
  const {
    state: { token, apiEndpoint, username },
    dispatch,
  } = useUserState();
  const { t } = useTranslate();
  const isMobile = getIsMobile();
  const { getApp } = useApp();

  const { mutateAsync: setLanguage } = useMutation({
    mutationFn: ({ language, sessionToken, loggedIn }: SetLanguageArgs) =>
      (username || loggedIn) && loggedIn !== false
        ? requestSetLanguageUser({ language }, sessionToken || token)
        : requestSetLanguage({ language }, sessionToken || token),
    onSuccess: async ({ success, sessionToken }, variables) => {
      if (sessionToken) {
        dispatch({ type: START_SESSION, payload: { sessionToken } });
      }
      if (success) {
        dispatch({ type: SET_LANGUAGE, language: variables.language });
        const newToken = sessionToken || variables.sessionToken || token;
        if (newToken !== null) {
          await getApp({ sessionToken: newToken });
        }
      } else {
        toast(t('toasts.failedChangeLanguage'));
      }
    },
  });

  const setLanguageOffline = ({ language }: SetLanguageArgs) => {
    dispatch({ type: SET_LANGUAGE, language });
  };

  return {
    setLanguage:
      !isMobile || (isMobile && apiEndpoint) ? setLanguage : setLanguageOffline,
  };
};
